// src/config/routeComponents.tsx
// menuRouterLink와 컴포넌트를 매핑하는 설정 파일
// 새 페이지 추가 시 여기에만 추가하면 됨

import { lazy, ComponentType } from "react";
import CollectionManagePage from "src/pages/CollectionManagePage";
import CouponManagePage from "src/pages/CouponManagePage";
import CouponIssuePage from "src/pages/CouponIssuePage";
import PromotionManagePage from "src/pages/PromotionManagePage";
import ProductCreatePage from "src/pages/ProductCreatePage";
import ProductUpdatePage from "src/pages/ProductUpdatePage";
import SkuCreatePage from "src/pages/SkuCreatePage";
import SkuUpdatePage from "src/pages/SkuUpdatePage";
import RewardManagePage from "src/pages/RewardManagePage";
import CampaignManagePage from "src/pages/CampaignManagePage";
import WarehouseManagePage from "src/pages/WarehouseManagePage";

// Lazy loading으로 코드 스플리팅
const AlimtalkManagePage = lazy(() => import("src/pages/AlimtalkManagePage"));
const DashboardPage = lazy(() => import("src/pages/DashboardPage"));
const MenuManagePage = lazy(() => import("src/pages/MenuManagePage"));
const RoleManagePage = lazy(() => import("src/pages/RoleManagePage"));
const CommonCodeManagePage = lazy(() => import("src/pages/CommonCodeManagePage"));
const TermsManagePage = lazy(() => import("src/pages/TermsManagePage"));
const NoticeManagePage = lazy(() => import("src/pages/NoticeManagePage"));
const CommonFaqPage = lazy(() => import("src/pages/CommonFaqPage"));
const DelegateManagePage = lazy(() => import("src/pages/DelegateManagePage"));
const SkuManagePage = lazy(() => import("src/pages/SkuManagePage"));
const UserManagePage = lazy(() => import("src/pages/UserManagePage"));
const DeliveryPolicyManagePage = lazy(() => import("src/pages/DeliveryPolicyManagePage"));
const BrandManagePage = lazy(() => import("src/pages/BrandManagePage"));
const ProductManagePage = lazy(() => import("src/pages/ProductManagePage"));
const PopupBannerManagePage = lazy(() => import("src/pages/PopupBannerManagePage"));
const PetBreedManagePage = lazy(() => import("src/pages/PetBreedManagePage"));
const PetHealthConcernManagePage = lazy(() => import("src/pages/PetHealthConcernManagePage"));
const CustomerManagePage = lazy(() => import("src/pages/CustomerManagePage"));
const CustomerDetailPage = lazy(() => import("src/pages/CustomerDetailPage"));
const ReviewManagePage = lazy(() => import("src/pages/ReviewManagePage"));
const OrderManagePage = lazy(() => import("src/pages/OrderManagePage"));
const OrderDetailPage = lazy(() => import("src/pages/OrderDetailPage"));
const StorageManagePage = lazy(() => import("src/pages/StorageManagePage"));

// menuRouterLink -> React Component 매핑
// 서버에서 내려오는 menuRouterLink 값과 정확히 일치해야 함
// 새 페이지 추가 시 이 맵에만 추가하면 App.tsx가 자동으로 라우트 생성
export const routeComponentMap: Record<string, ComponentType> = {
  // 대시보드
  "/": DashboardPage,

  // 공통 관리
  "/menu": MenuManagePage,
  "/role/management": RoleManagePage,
  "/code": CommonCodeManagePage,
  "/terms": TermsManagePage,
  "/notice": NoticeManagePage,
  "/faq": CommonFaqPage,
  "/delegate": DelegateManagePage,
  "/brand": BrandManagePage,
  "/collection": CollectionManagePage,

  // 상품 관리
  "/sku": SkuManagePage,
  "/sku/create": SkuCreatePage,
  "/sku/update/:id": SkuUpdatePage,
  "/product": ProductManagePage,
  "/product/create": ProductCreatePage,
  "/product/update/:id": ProductUpdatePage,
  "/popup-banner": PopupBannerManagePage,
  "/warehouse": WarehouseManagePage,

  // 고객 관리
  "/customer/pet-breed": PetBreedManagePage,
  "/customer/pet-concerns": PetHealthConcernManagePage,
  "/customer": CustomerManagePage,
  "/customer/:id": CustomerDetailPage,
  "/customer/review": ReviewManagePage,
  "/customer/talkmessage": AlimtalkManagePage,

  // 주문 관리
  "/order": OrderManagePage,
  "/order/:orderId": OrderDetailPage,

  // 사용자 관리
  "/manage/user": UserManagePage,
  "/manage/delivery-policy": DeliveryPolicyManagePage,
  "/manage/coupon": CouponManagePage,
  "/manage/coupon/issue": CouponIssuePage,
  "/promotion": PromotionManagePage,

  // 리워드 관리
  "/reward": RewardManagePage,

  // 캠페인 관리
  "/campaign": CampaignManagePage,

  // 스토리지 관리
  "/storage": StorageManagePage,
};

// 컴포넌트가 매핑된 모든 경로 목록
export const getAllMappedRoutes = (): string[] => {
  return Object.keys(routeComponentMap);
};

// 특정 경로에 대한 컴포넌트 반환
export const getRouteComponent = (path: string): ComponentType | null => {
  return routeComponentMap[path] || null;
};
